export const fromServerDateTimeToLocalized = ({
  i18n,
  serverDateTime,
}) => i18n.formatDate(i18n.dateParser({
  raw: 'yyyy-MM-ddTHH:mm:ss',
})(serverDateTime.substr(0, 19)), {
  datetime: 'short',
});
